import {ListItemButton, ListItemIcon, ListItemText, Typography, useTheme} from "@mui/material";
import {styled} from "@mui/system";
import {useDispatch, useSelector} from "react-redux";
import {appSetQuickAccess, appSetSettings} from "../../../store/actions/appAction";
import List from "@mui/material/List";
import {Fragment, memo, useState} from "react";
import shortid from "shortid";
import itemsSidebar from "../../../assets/js/itemsSidebar";
import Collapse from "@mui/material/Collapse";
import {IOSSwitch} from "../../Input/switch";
import ExpandLessIcon from "../../../assets/icons/ExpandLessIcon";
import ExpandMoreIcon from "../../../assets/icons/ExpandMoreIcon";
import {apiGetAppSettings, apiSetAlert, apiSetAppSettings} from "api/appApi";
import Messages from "lang/fa/messages";
// @ts-ignore

const StyledListItemText = styled(ListItemText)({
    textAlign: "right",
});
const SubListItemText = styled(ListItemText)({
    paddingRight: "30px",
});
const StyledListItemIcon = styled(ListItemIcon)({
    minWidth: "30px",
});
const ListContainer = styled("div")({
    padding: "20px",
});
const StyledListItemButton = styled(ListItemButton)(
    ({theme, active}: { theme?: ThemeObjType; active?: boolean }) => ({
        borderBottom: `solid 2px ${theme?.palette.disabled.light}`,
        padding: "12px 24px",
        backgroundColor: active ? "#EBF0FF52" : "none",
        "&:hover": {
            backgroundColor: "#EBF0FF52",
        },
    })
);

const SubItem = styled("div")({
    display: "flex",
    padding: "12px 24px",
});

const determineChecked = (list: any[], name: string) => {
    try {
        const index = list.findIndex((object) => object.name === name);
        if (index === -1) {
            return false;
        }
        return true;
    } catch {
        return false;
    }
};

const submitData = async (data: any, token: string, dispatch: any) => {
    // const token = useSelector((state: any) => state).businessReducer?.business?.token;
    try {
        await apiSetAppSettings({token: token, settings: data}).then((response) => {
            initialData(dispatch, token);
        });
    } catch (error) {
    } finally {
    }
};

const initialData = async (dispatch: (arg0: { type: string; value: any }) => void, token: string) => {
    // const dispatch = useDispatch();
    // const token = useSelector((state: any) => state).businessReducer?.business?.token;
    try {
        await apiGetAppSettings({token: token}).then((response) => {
            dispatch(appSetSettings(response?.data.settings));
        });
    } catch (error) {
    }
};

const SwitchControl = memo(({item, subItem}: { item: any; subItem: any }) => {
    //@ts-ignore
    const appState = useSelector((state) => state).appReducer;
    const quickAccess = appState.quickAccess;
    const dispatch = useDispatch();
    const quickAccessData = appState?.appSettings || [];
    const token = useSelector((state: any) => state).businessReducer?.business?.token;
    const onChange = (key: any, value: any) => {
        let temp = {
            ...quickAccessData,
            [key]: value,
        };
        return temp;
    };

    const settingSetQuickAccess = async(item: any, list: any[]) => {
        try {
            let temp = [...list];
            const index = list.findIndex((object: { name: any }) => object.name === item.name);
            if (index === -1) {
                if (list.length >= 11) {
                    // @ts-ignore
                    dispatch(apiSetAlert(Messages.dashboardQuickAccessLimit, "warning"));
                } else {
                    temp.push(item);
                }
            } else {
                const filtered = list.filter((object: { name: any }) => object.name !== item.name);
                temp = filtered;
            }

            const settings = onChange("quickAccess", JSON.stringify(temp));

            await submitData(settings, token, dispatch);

            return temp
        } catch {
            return list
        }
    };

    const handleChange = async(event: React.ChangeEvent<HTMLInputElement>) => {
        const newItems = await settingSetQuickAccess(
            {
                img: item.key,
                name: subItem.name,
                shortName: subItem.shortName,
                url: subItem.url,
            },
            quickAccess
        );

        dispatch(
            // @ts-ignore
            appSetQuickAccess(
                {
                    img: item.key,
                    name: subItem.name,
                    shortName: subItem.shortName,
                    url: subItem.url,
                },
                newItems,
                dispatch
            )
        );
    };

    return (
        <IOSSwitch
            defaultChecked={determineChecked(quickAccess as any[], subItem.name as string)}
            onChange={handleChange}
            checked={determineChecked(quickAccess as any[], subItem.name as string)}
            inputProps={{"aria-label": "controlled"}}
        />
    );
});

const ItemSwitchControl = memo(({item}: { item: any }) => {
    //@ts-ignore
    const appState = useSelector((state) => state).appReducer;
    const quickAccess = appState.quickAccess;
    const dispatch = useDispatch();
    const quickAccessData = appState?.appSettings || [];
    const token = useSelector((state: any) => state).businessReducer?.business?.token;
    const onChange = (key: any, value: any) => {
        let temp = {
            ...quickAccessData,
            [key]: value,
        };
        return temp;
    };

    const settingSetQuickAccess = async (item: any, list: any[]) => {
        try {
            let temp = [...list];
            const index = list.findIndex((object: { name: any }) => object.name === item.name);
            if (index === -1) {
                if (list.length >= 11) {
                    // @ts-ignore
                    dispatch(apiSetAlert(Messages.dashboardQuickAccessLimit, "warning"));
                } else {
                    temp.push(item);
                }
            } else {
                const filtered = list.filter((object: { name: any }) => object.name !== item.name);
                temp = filtered;
            }

            const settings = onChange("quickAccess", JSON.stringify(temp));

            await submitData(settings, token, dispatch);

            return temp
        } catch {
            return list
        }
    };

    const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const newItems = await settingSetQuickAccess(
            {
                img: item.key,
                name: item.name,
                shortName: item.name,
                url: item.url,
            },
            quickAccess
        );

        dispatch(
            // @ts-ignore
            appSetQuickAccess(
                {
                    img: item.key,
                    name: item.name,
                    shortName: item.name,
                    url: item.url,
                },
                newItems,
                dispatch
            )
        );
    };

    return (
        <IOSSwitch
            defaultChecked={determineChecked(quickAccess as any[], item.name as string)}
            onChange={handleChange}
            checked={determineChecked(quickAccess as any[], item.name as string)}
            inputProps={{"aria-label": "controlled"}}
        />
    );
});

const AddAccountModal = memo(() => {
    const items = itemsSidebar.items.filter((item) => item.urlName !== "Dashboard");
    const [open, setOpen] = useState(Array(items.length).fill(false));

    const theme = useTheme();

    const handleOpen = (key: number) => {
        open[key] = !open[key];
        setOpen([...open]);
    };
    return (
        <ListContainer>
            <List>
                {items &&
                    items.map((item, index) => (
                        <Fragment key={index}>
                            <StyledListItemButton disableRipple active={open[index]} onClick={() => handleOpen(index)}>
                                <StyledListItemIcon>
                                    <img src={item.img}/>
                                </StyledListItemIcon>
                                <StyledListItemText>
                                    <Typography
                                        variant="body1"
                                        color={open[index] ? theme.palette.text.primary : theme.palette.text.secondary}
                                    >
                                        {item?.name}
                                    </Typography>
                                </StyledListItemText>
                                {!item.subItem ? (
                                    <ItemSwitchControl item={item}/>
                                ) : open[index] ? (
                                    <ExpandLessIcon/>
                                ) : (
                                    <ExpandMoreIcon/>
                                )}
                            </StyledListItemButton>
                            <Collapse in={open[index]} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    {/* @ts-ignore */}
                                    {item?.subItem &&
                                        item?.subItem.map((subItem) => {
                                            if (!subItem?.url) return null;
                                            return (
                                                <SubItem key={shortid.generate()}>
                                                    <SubListItemText>
                                                        <Typography variant="body2"
                                                                    color={theme.palette.text.secondary}>
                                                            {subItem?.name}
                                                        </Typography>
                                                    </SubListItemText>
                                                    <SwitchControl item={item} subItem={subItem}/>
                                                </SubItem>
                                            );
                                        })}
                                </List>
                            </Collapse>
                        </Fragment>
                    ))}
            </List>
        </ListContainer>
    );
});

export default AddAccountModal;
